/* Kratus — promo-marquee: reveal de entrada + pausa en hover via GSAP.
   El loop infinito en si es CSS puro (section-promo-marquee.css); esto solo
   cubre el detalle fino que pidio Tony. */

window.KratusMotion && window.KratusMotion.ready('promo-marquee', function (root) {
  var bars = root.querySelectorAll('[data-promo-marquee]');
  if (!bars.length) return;

  window.KratusMotion.mm.add(
    { reduceMotion: '(prefers-reduced-motion: reduce)' },
    function (context) {
      var reduceMotion = context.conditions.reduceMotion;

      bars.forEach(function (bar) {
        gsap.from(bar, {
          yPercent: -100,
          autoAlpha: 0,
          duration: reduceMotion ? 0 : 0.6,
          ease: 'power2.out',
        });

        bar.addEventListener('mouseenter', function () {
          bar.setAttribute('data-paused', 'true');
        });
        bar.addEventListener('mouseleave', function () {
          bar.removeAttribute('data-paused');
        });
      });
    }
  );
});
